if (!customElements.get('progress-circle')) {
  customElements.define(
    'progress-circle',
    class ProgressCircle extends HTMLElement {
      constructor() {
        super();
        this.data = JSON.parse(this.querySelector('[type="application/json"]').textContent);
        this.init();
      }
      //绘制auto offer部分的circle progress
      renderCircleProgress(element, highestCashback, progressRadio, circleR, circleStrokeWidth, centralAngleRadio, headingClass, textClass) {
        const pi = Math.PI;
        const circlePerimeter = 2 * pi * circleR;
        const centerXY = circleR + 0.5 * circleStrokeWidth;
        const ArcLengthOut = (1 - centralAngleRadio) * circlePerimeter;
        const rotateAngel = (0.75 - 0.5 * centralAngleRadio) * 360;
        const progressCentralAngleRadio = progressRadio > 0.91 && progressRadio < 1 ? centralAngleRadio * 0.91 : centralAngleRadio * progressRadio;
        const progressArcLengthOut = (1 - progressCentralAngleRadio) * circlePerimeter;
        const checkMarkFillColor = progressRadio == 1 ? 'color-progress-bar' : 'color-progress-bg';
        const checkMarkColor = progressRadio == 1 ? 'color-section-bg' : 'color-progress-check';
        const circleHeight = (Math.cos((1 - centralAngleRadio) * pi) + 1) * centerXY + (1 - 0.35 * Math.sqrt(2)) * circleStrokeWidth;
        const checkBoxR = circleStrokeWidth - 1;
        // const checkBoxX = (Math.sin((1 - centralAngleRadio) * pi) + 1) * centerXY - (checkBoxR * 2 - centralAngleRadio * circleStrokeWidth)
        const checkBoxX =
          centerXY + Math.sqrt((circleR - 0.5 * circleStrokeWidth) * (circleR - 0.5 * circleStrokeWidth) - checkBoxR * checkBoxR) - 1.2 * checkBoxR;
        const checkBoxY = circleHeight - 2 * checkBoxR;
        const checkX = checkBoxX + checkBoxR - 5;
        const checkY = checkBoxY + checkBoxR - 4;
        const svgHeight = circleHeight;
        const svgWidth = 2 * centerXY;

        console.log('progressRadio: ' + progressRadio);

        const circleSvg = `<svg width="${svgWidth}" height="${svgHeight}" viewBox="0 0 ${svgWidth} ${svgHeight}" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="${centerXY}" cy="${centerXY}" r="${circleR}" fill="none" class="color-progress-bg-stroke" stroke-width="${circleStrokeWidth}" stroke-dasharray="${circlePerimeter}" stroke-linecap="round" stroke-dashoffset="${ArcLengthOut}" transform="rotate(${rotateAngel}, ${centerXY}, ${centerXY})" shape-rendering="geometricPrecision"></circle>
          <circle cx="${centerXY}" cy="${centerXY}" r="${circleR}" stroke-width="${circleStrokeWidth}"  stroke-dasharray="${circlePerimeter}" stroke-dashoffset="${progressArcLengthOut}" transform="rotate(${rotateAngel},  ${centerXY}, ${centerXY})" fill="none" class="color-progress-bar-stroke" shape-rendering="geometricPrecision" stroke-linecap="round" stroke-dasharray="314.1592653589793" stroke-dashoffset="278.81634800609413" style="transition: stroke-dashoffset 1000ms ease-in-out 0s;"></circle>
          <rect x="${checkBoxX}" y="${checkBoxY}" width="${2 * checkBoxR}" height="${2 * checkBoxR}" rx="${checkBoxR}" class="${checkMarkFillColor}"/>
          <g clip-path="url(#clip0_89_37)"  transform="translate(${checkX}, ${checkY})">
            <path d="M7.7338 0.922462L3.53846 5.1178L2.0098 3.58913C1.88406 3.46769 1.71566 3.40049 1.54086 3.40201C1.36607 3.40353 1.19886 3.47364 1.07525 3.59725C0.951646 3.72086 0.881534 3.88806 0.880015 4.06286C0.878496 4.23766 0.945692 4.40606 1.06713 4.5318L3.06713 6.5318C3.19215 6.65678 3.36169 6.72699 3.53846 6.72699C3.71524 6.72699 3.88478 6.65678 4.0098 6.5318L8.67646 1.86513C8.7979 1.73939 8.8651 1.57099 8.86358 1.39619C8.86206 1.2214 8.79195 1.05419 8.66834 0.930583C8.54474 0.806978 8.37753 0.736865 8.20273 0.735346C8.02793 0.733827 7.85953 0.801024 7.7338 0.922462V0.922462Z" class="${checkMarkColor}"/>
          </g>
          <text x="50%" y="53%" dominant-baseline="middle" text-anchor="middle" font-weight="700" class="${headingClass} color-progress-text">$${highestCashback}</text>
          <text x="50%" y="83%" dominant-baseline="middle" text-anchor="middle" font-weight="500" class="${textClass} color-progress-text">back</text>
        </svg>`;
        element.innerHTML = circleSvg;
      }

      init() {
        const { highestCashback, subtotal, highestQualifier, circleStrokeWidth, circleR, centralAngleRadio, headingClass, textClass } = this.data;
        const progressRadio = subtotal >= highestQualifier ? 1 : parseFloat((subtotal / highestQualifier).toFixed(4));
        const container = this.querySelector('.wyze-tiered-offer-progress');
        this.renderCircleProgress(
          container,
          (highestCashback / 100).toFixed(0),
          progressRadio,
          circleR,
          circleStrokeWidth,
          centralAngleRadio,
          headingClass,
          textClass
        );
      }
    }
  );
}
